export const LOADED = 'cod:loaded';
export const ERROR = 'cod:error';
export const IMPRESSION = 'cod:impression';
export const NO_IMAGES = 'cod:noimages';
export const TAGGED = 'cod:taggedcreative';

export type COD_COUNTERS = typeof LOADED | typeof ERROR | typeof IMPRESSION | typeof NO_IMAGES | typeof TAGGED;
